<template>
  <div class="operator-card" part="card" ref="cardRef">
    <div class="operator-image-container">
      <a :href="operator.link" target="_blank">
        <img
          ref="imageRef"
          class="operator-image"
          :src="optimizedImageUrl"
          :alt="operator.title?.rendered || 'Operator image'"
          @click="operator.link"
        />
      </a>
      <div
        v-if="operator.website_category && operator.website_category.includes(182)"
        class="operator-category"
      >
        <span class="event-next-occurrence">{{ operator.next_occurrence }}</span>
        <span class="event-frequency" v-if="operator.frequency !== 'Once Only'">{{
          operator.frequency
        }}</span>
      </div>
    </div>
    <button @click="handleViewOnMap" v-if="!isListView" class="view-on-map flex rounded-full">
      <span class="view-on-map-label"> View on map </span>
      <svg
        id="Layer_2"
        class="view-on-map-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35.61 43.25"
      >
        <g id="Layer_1-2">
          <path
            d="M17.02,43.07h0c.5.22.78.17.78.17,0,0,.28.05.78-.17h0s.02-.01.02-.01l.05-.02c.24-.11.48-.23.71-.36.47-.24,1.13-.61,1.93-1.1,1.58-.98,3.68-2.46,5.78-4.49,4.21-4.06,8.53-10.41,8.53-19.29C35.61,7.97,27.64,0,17.81,0S0,7.97,0,17.81c0,8.88,4.32,15.23,8.53,19.29,1.76,1.69,3.7,3.2,5.78,4.49.81.5,1.63.96,2.48,1.38l.16.07.05.02h.02ZM17.81,23.53c3.16,0,5.72-2.56,5.72-5.72s-2.56-5.72-5.72-5.72-5.72,2.56-5.72,5.72,2.56,5.72,5.72,5.72Z"
            style="fill: #002855; fill-rule: evenodd"
          />
        </g>
      </svg>
    </button>
    <!-- <div v-if="operator.website_category && operator.website_category.includes(182)" class="operator-category">
      <span class="event-date-range">{{ operator.event_date_range }}</span>
    </div> -->
    <h3 class="line-clamp-2 leading-tight operator-title" :title="operator.title?.rendered">
      <a :href="operator.link" target="_blank" v-html="operator.title?.rendered"></a>
    </h3>
    <div class="flex flex-col sm:flex-row gap-2">
      <div class="operator-card-trip-planner-button" part="trip-planner-button">
        <TripPlannerButton :id="operator.id" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, onMounted, onUnmounted } from "vue";
import TripPlannerButton from "./TripPlannerButtonTransition.vue";
const viewStore = useViewStore();
const { isListView } = storeToRefs(viewStore);
import { storeToRefs } from "pinia";
import { useViewStore } from "../stores";
// import { lazyLoader } from '../utils/performance.js'

const props = defineProps({
  operator: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["view-on-map"]);

// Refs
const cardRef = ref(null);
const imageRef = ref(null);

const optimizedImageUrl = computed(() => {
  const url = props.operator.featured_media;
  if (!url) return url;
  return url.replace(/w=\d+/, "w=600");
});

const handleViewOnMap = () => {
  emit("view-on-map");
};
</script>

<style scoped>
.operator-card {
  font-size: var(--vwc-card-font-size);
  font-family: var(--vwc-card-font);
  font-weight: var(--vwc-card-font-weight);
  color: var(--vwc-card-font-color);
  border-radius: var(--vwc-border-radius-md);
  padding: var(--vwc-card-padding);
  position: relative;
}

.operator-image-container {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: var(--vwc-card-image-border-radius);
  overflow: hidden;
  background-color: var(--vwc-color-secondary);

  @media screen and (max-width: 640px) {
    height: 35vw;
  }
}

.operator-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: opacity 0.3s ease;
}

.operator-title {
  font-size: var(--vwc-card-title-font-size);
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: 1.2em;
  min-height: 2.2em;
  margin-top: var(--vwc-spacing-sm);
}

.operator-title a {
  color: inherit;
  text-decoration: none;
}

.view-on-map {
  background: var(--vwc-operator-card-background);
  padding: 0.5em 1em 0.5em 1em;
  font-size: 9px;
  position: absolute;
  top: 10px;
  left: 10px;
  border: 0;
  box-shadow: var(--vwc-shadow-sm);
  z-index: 2;
  font-family: inherit;
}

.view-on-map-icon {
  width: 8px;
  margin-right: 5px;
  margin-left: 5px;
}

.view-details {
  font-size: 10px;
  border: 1.5px solid var(--vwc-color-border);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: inherit;
  text-decoration: none;
  padding: var(--vwc-spacing-sm);
  transition: all 0.2s ease;
}

.view-details:hover {
  background-color: var(--vwc-color-secondary);
  transform: translateY(-1px);
}

.event-frequency {
  position: absolute;
  top: 10px;
  left: 10px;
  background: black;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 10px;
}
.event-next-occurrence {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: black;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 10px;
}
</style>
